module.exports = __webpack_public_path__ + "static/img/female-4.b915cab4.png";